import { Box } from "@mui/material";
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    currentIndex: number;
}

const TabPanel = (props: TabPanelProps) => {
    const { children, currentIndex, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={currentIndex !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
          <Box sx={{ p: 3 }}>
            {children}
          </Box>
      </div>
    );
}


export default TabPanel;
